// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EcoStatsDataUsage
 */
export interface EcoStatsDataUsage {
    /**
     * 
     */
    total?: number;
    /**
     * 
     */
    high?: number;
    /**
     * 
     */
    low?: number;
    /**
     * 
     */
    off?: number;
    /**
     * 
     */
    open?: number;
}

/**
 * Check if a given object implements the EcoStatsDataUsage interface.
 */
export function instanceOfEcoStatsDataUsage(value: object): value is EcoStatsDataUsage {
    return true;
}

export function EcoStatsDataUsageFromJSON(json: any): EcoStatsDataUsage {
    return EcoStatsDataUsageFromJSONTyped(json, false);
}

export function EcoStatsDataUsageFromJSONTyped(json: any, ignoreDiscriminator: boolean): EcoStatsDataUsage {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'] == null ? undefined : json['total'],
        'high': json['high'] == null ? undefined : json['high'],
        'low': json['low'] == null ? undefined : json['low'],
        'off': json['off'] == null ? undefined : json['off'],
        'open': json['open'] == null ? undefined : json['open'],
    };
}

export function EcoStatsDataUsageToJSON(json: any): EcoStatsDataUsage {
    return EcoStatsDataUsageToJSONTyped(json, false);
}

export function EcoStatsDataUsageToJSONTyped(value?: EcoStatsDataUsage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'high': value['high'],
        'low': value['low'],
        'off': value['off'],
        'open': value['open'],
    };
}

